module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-mobile-01-5758ff1e.jpg";